import React from 'react';
import { config } from '../Constants';
import SelectParkingZone from './selectParkingZoneView';
import ConfirmedView from './confirmedView';
import AlreadyTakenView from './alreadyTaken';
import axios from 'axios';
import Papa from 'papaparse'
import PermissionError from './permissionError';
// import moment from "moment"
const moment = require('moment-timezone');

export default class VisitorPass extends React.Component {

  constructor() {
    super();
    this.state = {
      API_URL: config.url.API_URL,
      submitted: false,
      showConfirmation: false,
      showForm: false,
      isAlreadyTaken: false,
      isFreeHourExpired: false,
      isIOS: false,
      freeHours: '',
      startDate: Date,
      endtDate: Date,
      ZoneCode: String,
      zoneQuery: false,
      zoneList: [],
      currentZone: [],
      parkingOptionList: [],
      installationList: [],
      visitorPassResponse: '',
      currentParkingOption: [],
      ParkingOption: [],
      visitorPassConfirmation: {},
      ZoneId: '',
      PlateNumber: '',
      formData: {},
      sheetData: {},
      userLanguage: '',
      purchasedConsecutive: false,
      permissionError: false
    }
  }


  componentDidMount() {
    var userLang = navigator.language || navigator.userLanguage;
    this.setState({ userLanguage: userLang })

    this.getAllZones();
    this.getAllInstallations();
    // this.getLocalData(); 
    this.getGoogleSheetData();
  }

  getGoogleSheetData() {
    Papa.parse("https://docs.google.com/spreadsheets/d/1uJASzNfN-aiu3GFnPAggI9YCrtT4_NxNtgAs-6U52E4/export?format=csv&gid=0", {
    // Papa.parse("https://docs.google.com/spreadsheets/d/19v2WbZtUApzDHlE-fkjPPe5RJ9tVUzSfF0EmhAh8-pQ/pub?gid=1655665746&output=csv", {
      download: true,
      header: true,
      complete: (res) => {
        let result = this.mapLanguages(this.state.userLanguage, res.data);
        this.setState({ sheetData: result }, () => { console.log(this.state.sheetData) })
      },
    });
    // axios.get("https://sheet.best/api/sheets/135a1d49-6321-484e-b93e-e00287b52292/tabs/English").then((res)=>{
    //   console.log(res);
    //   let result = this.mapLanguages(this.state.userLanguage, res.data);
    //   this.setState({sheetData : result}, ()=>{console.log(this.state.sheetData)})
    // })
    // Tabletop.init({
    //   key: 'https://docs.google.com/spreadsheets/d/19v2WbZtUApzDHlE-fkjPPe5RJ9tVUzSfF0EmhAh8-pQ/edit?usp=sharing',
    //   callback: googleData => {                     
    //       let result = this.mapLanguages(this.state.userLanguage, googleData.English.elements);
    //       console.log(googleData.English.elements)
    //       this.setState({sheetData : result}, ()=>{console.log(this.state.sheetData)})
    //   },
    //   simpleSheet: false
    // })
  }

  mapLanguages(language, languageData) {
    let languageArray = [];
    languageData.forEach((item) => {
      if (item[language] !== undefined || item[language.split('-')[0]] !== undefined) {
        languageArray[item.key] = item[language] || item[language.split('-')[0]];
      } else {
        languageArray[item.key] = item['en'];
      }
    })
    return languageArray;
  }

  getLocalData() {
    let savedPlateNo = localStorage.getItem('vpp-PlateNo');
    savedPlateNo = JSON.parse(savedPlateNo);
    let form = {
      PlateNo: savedPlateNo
    }
    this.setState({
      formData: form
    })
  }

  getAllZones() {
    axios.get(this.state.API_URL + '/GetAllParkingZones')
      .then(response => {
        const userLogged = JSON.parse(sessionStorage.getItem("userLogged"));
        const allowedZones = response.data.zones.filter(item => userLogged.zones.replace(/"/g, '').split(',').includes(item.zoneCode));
        let ZoneCode = this.props.match.params.id;
        let filteredZoneCode = allowedZones.filter(x => x.zoneCode == ZoneCode);
        if (!allowedZones.length || (ZoneCode && !filteredZoneCode.length)) {
          this.setState({ permissionError: true });
          return;
        }
        this.setState({
          zoneList: allowedZones,
          ZoneId: allowedZones[0].id
        })
        if (ZoneCode && filteredZoneCode.length === 0) {
          this.props.history.push('/')
        }
        else if (ZoneCode && filteredZoneCode.length > 0) {
          this.setState({ zoneQuery: true, currentZone: filteredZoneCode })
          this.setState({
            ZoneId: this.state.currentZone[0].id,
          })
        }
        this.getAllOptions(allowedZones[0].id);
      });
  }

  getAllOptions(zoneId) {
    axios.get(this.state.API_URL + '/GetAllParkingOptions')
      .then(response => {
        this.setState({ parkingOptionList: response.data.options })
        var newCurrentParkingOption = response.data.options.filter(x => x.zoneId === zoneId);
        this.setState({
          currentParkingOption: newCurrentParkingOption,
          ParkingOption: newCurrentParkingOption[0].id,
          formData: { parkingOption: newCurrentParkingOption[0].optionCode }
        })
        let ZoneCode = this.props.match.params.id;
        let filteredZoneCode = this.state.zoneList.filter(x => x.zoneCode === ZoneCode);
        if (ZoneCode && filteredZoneCode.length === 0) {
          this.props.history.push('/')
        } else if (ZoneCode && filteredZoneCode.length > 0) {
          let test = this.state.zoneList.filter(x => x.zoneCode === ZoneCode);
          let options = this.state.parkingOptionList.filter(x => x.zoneId === test[0].id);
          this.setState({
            currentParkingOption: options,
            ParkingOption: options[0].id,
            formData: { parkingOption: options[0].optionCode },
            freeHours: options[0].hours
          })
        }
        this.setState({
          showForm: true
        })
      });
  }

  getAllInstallations() {
    axios.get(this.state.API_URL + '/GetAllInstallations')
      .then(response => {
        this.setState({
          installationList: response.data.installations
        })
      });
  }

  onZoneChange(value) {
    let filterOptions = this.state.parkingOptionList.filter(x => x.zoneId == value);
    this.setState({ ParkingOption: -1 });
    this.setState({
      currentParkingOption: filterOptions,
      ZoneId: filterOptions[0].zoneId,
      formData: { parkingOption: filterOptions[0].optionCode }
    }, () => {
      console.log(this.state.currentParkingOption, this.state.ZoneId);
    });
  }

  handleChange(event, obj) {
    let form = this.state.formData;
    form[event.target.name] = event.target.name == 'parkingOption' ?
      this.state.parkingOptionList.find(x => x.id == event.target.value).optionCode : event.target.value;
    this.setState({
      formData: form
    }, () => { console.log(this.state.formData) });
    if (event.target.name == 'parkingOption') {
      let hours = this.state.parkingOptionList.find(x => x.id == event.target.value).hours;
      this.setState({
        freeHours: hours
      });
    }
  }

  checkLocalParkings() {
    let parkings = JSON.parse(localStorage.getItem('parkings')) || [];
    let parkingPurchase = [];
    for (let i = 1; i < 4; i++) {
      let date = moment(new Date()).subtract(i, 'd').format("DDMMYYYY")
      let findDate = parkings.find(x => x.date == date && x.plate == this.state.formData['PlateNo'])
      if (findDate) {
        parkingPurchase.push(findDate)
      }
    }
    if (parkingPurchase.reduce((acc, o) => acc + parseInt(o.hours), 0) >= 72) {
      this.setState({ purchasedConsecutive: true })
      return true;
    }
  }

  onSubmit() {
    if (this.checkLocalParkings()) {
      return;
    }
    // return;
    let findRate = this.state.parkingOptionList.find(x => x.optionCode == this.state.formData.parkingOption)
    let parkings = JSON.parse(localStorage.getItem('parkings')) || [];
    parkings.push({
      plate: this.state.formData['PlateNo'],
      date: moment(new Date()).format("DDMMYYYY"),
      hours: findRate.hours,
      grp_id: this.state.zoneList.find(x => x.id == this.state.ZoneId).zoneCode,
    })
    localStorage.setItem('parkings', JSON.stringify(parkings));
    this.setState({ submitted: true })
    if (this.state.zoneQuery == true) {
      this.setState({ ParkingOption: this.state.currentParkingOption[0].id })
    } else if (!this.state.zoneQuery) {
      this.setState({ ParkingOption: this.state.currentParkingOption[0].id })
    }
    if (this.state.ParkingOption === -1 || this.state.ZoneId == undefined || this.state.ZoneId == null) {
      return;
    }
    let selectedOption = this.state.currentParkingOption.filter(x => x.id == this.state.ParkingOption);
    let selectedZone = this.state.zoneList.filter(x => x.id == this.state.ZoneId);
    let installation = this.state.installationList.filter(x => x.id == selectedZone[0].installationId)
    const iParkIn = {
      ins_id: installation[0].installationCode,
      lic_pla: this.state.formData['PlateNo'].toUpperCase(),
      date: moment(new Date()).format("HHmmssDDMMYYYY"),
      grp_id: selectedZone[0].zoneCode,
      tar_id: this.state.formData.parkingOption,
      amou_off: "5",
      prov: "VISITOR_PASS",
      vers: "1.0",
      ah: ""
    }

    const amountSteps = {
      ipark_in: iParkIn
    }

    const headerOptions = { 'Content-Type': 'application/json' };
    const amountStepsReq = JSON.stringify(amountSteps);

    axios.post(this.state.API_URL + '/SubmitVisitorPass', amountStepsReq, { headers: headerOptions })
      .then(result => {
        this.setState({ visitorPassResponse: result.data })
        var freeMinutes = this.state.visitorPassResponse.ipark_out.t_min;
        var convertIntoHours = freeMinutes / 60;
        this.setState({ freeHours: convertIntoHours })
        if (this.state.visitorPassResponse.ipark_out.r == "1") {
          this.setState({ showConfirmation: true })
          if (this.state.visitorPassResponse.ipark_out.t_min != "0") {
            var d_init = moment(this.state.visitorPassResponse.ipark_out.d_init, "MM/DD/YYYY hh:mm:ss a").format('"MM/DD/YYYY hh:mm:ss a"');
            var d_min = moment(this.state.visitorPassResponse.ipark_out.d_min, "MM/DD/YYYY hh:mm:ss a").format('"MM/DD/YYYY hh:mm:ss a"');
            this.setState({ startDate: d_init, endtDate: d_min })
            let hours = parseInt(this.state.visitorPassResponse.ipark_out.t_min) / 60;
            let passConfirmation = {
              CNo: "CN000001",
              Hours: hours,
              RemainingVisitors: 2,
              ParkingZone: selectedZone[0].name,
              ZoneCode: selectedZone[0].zoneCode
            }
            this.setState({
              visitorPassConfirmation: passConfirmation,
            })
          } else {
            let device = this.getMobileOperatingSystem();
            if (device == "iOS") {
              this.isIOS = true;
            } else {
              this.isIOS = false;
            }
            this.setState({ isAlreadyTaken: true })
            this.setState({ startDate: moment(this.state.visitorPassResponse.ipark_out.d_min, "MM/DD/YYYY hh:mm:ss a").format('"MM/DD/YYYY hh:mm:ss a"') })
            this.setState({ endtDate: moment(this.state.visitorPassResponse.ipark_out.d_max, "MM/DD/YYYY hh:mm:ss a").format('"MM/DD/YYYY hh:mm:ss a"') })
            let passConfirmation = {
              ParkingZone: selectedZone[0].name,
              ZoneCode: selectedZone[0].zoneCode
            }
            this.setState({
              visitorPassConfirmation: passConfirmation
            })

            let currentDate = new Date();
            let sd = new Date(this.state.startDate);
            let seconds = (sd.getTime() - currentDate.getTime()) / 1000;
            if (seconds > 0) {
              this.isFreeHourExpired = false;
            } else {
              this.isFreeHourExpired = true;
            }
          }

        }
        else {
          let passConfirmation = {
            success: false
          }
          this.setState({ visitorPassResponse: passConfirmation })
        }
      });
    localStorage.setItem('vpp-PlateNo', JSON.stringify(this.state.formData['PlateNo']))
  }

  resetForm() {
    window.location.reload();
  }

  clearPlateNo(e) {
    let form = {
      parkingOption: this.state.formData['parkingOption'],
      PlateNo: ""
    }
    this.setState({
      formData: form
    })
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;// || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.setState({ isIOS: true })
      return "iOS";
    }

    return "unknown";
  }

  logout() {
    sessionStorage.removeItem("userLogged");
    this.props.history.push('/login');
  }

  render() {
    return (
      <div>
        {(this.state.showForm && !this.state.showConfirmation) && <SelectParkingZone zoneList={this.state.zoneList} option={this.state.currentParkingOption}
          zoneQuery={this.state.zoneQuery} showForm={this.state.showForm} freeHours={this.state.freeHours}
          currentZone={this.state.currentZone} onZoneChange={(e) => { this.onZoneChange(e) }}
          handleChange={(e) => { this.handleChange(e) }} formData={this.state.formData} onSubmit={() => { this.onSubmit() }}
          resetForm={() => { this.resetForm() }} clearPlateNo={() => { this.clearPlateNo() }}
          sheetData={this.state.sheetData} purchasedConsecutive={this.state.purchasedConsecutive}
          logout={() => { this.logout() }} />}

        {this.state.showConfirmation && !this.state.isAlreadyTaken &&
          <ConfirmedView
            freeHours={this.state.freeHours}
            visitorPassModel={this.state.formData}
            visitorPassConfirmation={this.state.visitorPassConfirmation}
            startDate={this.state.startDate}
            endtDate={this.state.endtDate}
            sheetData={this.state.sheetData}
            resetForm={() => { this.resetForm() }}
            logout={() => { this.logout() }}
          />}

        {(this.state.showConfirmation && this.state.isAlreadyTaken) &&
          <AlreadyTakenView
            visitorPassModel={this.state.formData}
            isFreeHourExpired={this.state.isFreeHourExpired}
            visitorPassConfirmation={this.state.visitorPassConfirmation}
            startDate={this.state.startDate} isIOS={this.state.isIOS}
            sheetData={this.state.sheetData}
            resetForm={() => { this.resetForm() }}
            logout={() => { this.logout() }}
          />}
        {this.state.permissionError && <PermissionError sheetData={this.state.sheetData} logout={() => { this.logout() }} />}
      </div>
    )
  }
}
